import {BrightnessContrast, ColorAverage, EffectComposer, HueSaturation, ToneMapping} from "@react-three/postprocessing";
import { ToneMappingMode } from "postprocessing";
import {isDefined, isDefinedNotZero} from "../utils/isDefined";

const NORMAL_BLEND = 23;

export const PostProcessing = ({ brightness, contrast, hue, saturation, hueSaturationBlendMode, colorAverageBlendMode, mode, ...rest }) => {
    const isBrightnessContrast = isDefinedNotZero(brightness) || isDefinedNotZero(contrast);
    const isHueSaturation = isDefinedNotZero(hue) || isDefinedNotZero(saturation);
    const isColorAverage = isDefined(colorAverageBlendMode);
    const hueSaturationBlendModeNormalized = isDefined(hueSaturationBlendMode) ? hueSaturationBlendMode : NORMAL_BLEND;

    return (
        <EffectComposer {...rest}>
            {(mode !== 'none') && <ToneMapping mode={toneMappingDict.get(mode)}/>}
            {isColorAverage && <ColorAverage blendFunction={colorAverageBlendMode} />}
            {isBrightnessContrast && <BrightnessContrast brightness={brightness} contrast={contrast} />}
            {isHueSaturation && <HueSaturation blendFunction={hueSaturationBlendModeNormalized} hue={hue} saturation={saturation} />}
        </EffectComposer>
    );
};

const toneMappingDict = new Map([
    ["none", ToneMappingMode.LINEAR],
    ["linear", ToneMappingMode.LINEAR],
    ["reinhard", ToneMappingMode.REINHARD],
    ["cineon", ToneMappingMode.CINEON],
    ["ACESFilmic", ToneMappingMode.ACES_FILMIC], // Old - default value
    ["aces", ToneMappingMode.ACES_FILMIC],
    ["agx", ToneMappingMode.AGX],
    ["neutral", ToneMappingMode.NEUTRAL],
]);
